import React from 'react';

import Link from 'components/link';
import { useFormatCalories } from 'hooks/use-format-calories';
import {
  MenuSectionGridFooter,
  MenuSectionGridItemWrapper,
  MenuSectionImage,
  MenuSectionItemCalories,
  MenuSectionItemPrice,
  MenuSectionProductWrapper,
} from 'pages/menu/components/menu-section/styled';
import { IMenuSectionItemProps } from 'pages/menu/components/menu-section/types';
import { buildMenuLink } from 'pages/menu/utils/navigation';
import { useUIContext } from 'state/ui';

export const MenuSectionGridItem: React.FC<IMenuSectionItemProps> = ({
  item,
  objectFitContain,
}) => {
  const { formatCurrencyForLocale } = useUIContext();
  const formatCalories = useFormatCalories();

  const linkPath = buildMenuLink(item);

  return (
    <MenuSectionGridItemWrapper>
      <Link style={{ width: '100%', height: '100%', flexDirection: 'column' }} linkPath={linkPath}>
        <MenuSectionImage
          image={item.image.resource}
          alt={item.image.description}
          objectFitContain={objectFitContain}
        />
        <MenuSectionGridFooter isMenuItem={!!item.product}>
          {item.name}
          {item.product && (
            <MenuSectionProductWrapper>
              <MenuSectionItemPrice>
                {formatCurrencyForLocale(item.product.price)}
              </MenuSectionItemPrice>
              <MenuSectionItemCalories>
                {formatCalories(item.product.calories)}
              </MenuSectionItemCalories>
            </MenuSectionProductWrapper>
          )}
        </MenuSectionGridFooter>
      </Link>
    </MenuSectionGridItemWrapper>
  );
};
